import Loadable from 'react-loadable';
import { skeletonLoader } from '@/components/uikit';

const dynamicImport = <P>(
  modules: unknown,
  loadingComponent?: React.ComponentType
) => {
  return Loadable({
    loader: () => modules,
    loading: loadingComponent || skeletonLoader,
  } as LoadableExport.OptionsWithoutRender<P>);
};

export default dynamicImport;
